import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-menu-tech',
  templateUrl: './nav-menu-tech.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponentTech {
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
